export default "__VITE_ASSET__CBFJ6rlW__"